import { ExploreCard } from "./ExploreCard";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../useTheme";
import defaultImage from "../../assets/default.png"

export function ExploreSection({ data, appData }) {
  const navigate = useNavigate();
  const theme = useTheme();


  const handleClick = (item) => {
    navigate(`/collection/${item.publicId}`)
  }
  return (
    <section
      aria-label="Explore section"
      style={{ display: "flex", flexDirection: "column", gap: "clamp(16px, 3vw, 24px)" }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "clamp(8px, 1.5vw, 12px)" }}>
          <h1
            style={{
              margin: 0,
              fontSize: "clamp(20px, 5vw, 36px)",
              fontWeight: 700,
              letterSpacing: "-0.02em",
              color: "var(--theme-text, #212529)",
              marginTop: "clamp(16px, 3vw, 60px)",
            }}
          >
            {theme.exploreTitle}
          </h1>
          <p
            style={{
              margin: 0,
              fontSize: "clamp(14px, 2.5vw, 22px)",
              fontWeight: 400,
              lineHeight: 1.6,
              padding: "20px",
              color: "var(--theme-textSecondary, #6c757d)",
              maxWidth: "100%",
            }}
          >
            {theme.exploreDescription}
          </p>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 280px), 1fr))",
          gap: "clamp(16px, 3vw, 24px)",
        }}
      >
        {data.map((item,index) => {
          return (
            <ExploreCard
              key={`Collection-${index}`}
              title={item?.sharableData?.collectionLabel}
              subtitle={item?.sharableData?.subtitle}
              imageUrl={item?.sharableData?.portraitUrl || defaultImage}
              tokens={item?.tokens || []}
              onClick={() => handleClick(item)}
            />
          );
        })}
      </div>

      {/* <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 6 }}>
        <Button
          variant="primary"
          type="button"
          style={{
            borderRadius: 999,
            padding: '10px 18px',
            fontWeight: 600,
            borderColor: 'transparent',
            background: 'var(--theme-surface, #f8f9fa)',
            color: 'var(--theme-text, #212529)',
          }}
        >
          Browse more
        </Button>
      </div> */}
    </section>
  );
}
